import React from 'react'
import { DividerLine } from '../../../../components/atoms/lines/DividerLine'
import JsonCodeView from '../../../../components/organisms/codeView/JsonCodeView'
import {
  jobsContextDirectArraySample,
  jobsContextSample,
  jsonLocationsSample,
  jsonProductionImagesSample
} from './SampleXmlJsonData'

const MappingHelperJson: React.FC = () => {
  return (
    <div className='MappingHelper pageContainer'>
      <h1>Json path mapping guide</h1>
      <h3>Jobs list context</h3>
      <JsonCodeView json={jobsContextSample} />
      <h3>In the example above:</h3>
      <h4>Jobs list context is the array which contains all of job postings, which is:</h4>
      <p>
        <span>Job list context: </span>
        <span>stellen</span>
      </p>
      <h4>But sometimes the response data gives directry the list of jobs</h4>
      <JsonCodeView json={jobsContextDirectArraySample} />
      <h4>So we leave this field empty!</h4>
      <DividerLine />
      <h3>Root fields</h3>
      <h4>Earlier we have defined the job path, so to map the Id, we can easily input:</h4>
      <p>
        <span>id: </span>
        <span>handle</span>
      </p>
      <DividerLine />
      <h3>Locations</h3>
      <JsonCodeView json={jsonLocationsSample} />
      <h4>
        Its possible to have multiple locations, so first, in field &apos;locations&apos; we define
        the path which includes all locations, and then the child path for each item (ex:
        locations/location):
      </h4>
      <div className='inline-code'>
        <span>locations: </span>
        <span>allLocations</span>
      </div>
      <h3>Production Images</h3>
      <JsonCodeView json={jsonProductionImagesSample} />
      <h4>
        Its possible to have multiple production images, so first, in field &apos;productionImagesContext&apos; we define
        the path which includes all production images, and then the child paths for id and url (ex:
        production_images/image):
      </h4>
      <div className='inline-code'>
        <span>productionImagesContext: </span>
        <span>allProductionImages</span>
      </div>
    </div>
  )
}

export default MappingHelperJson
